import React from 'react';
import { Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { SimpleFormStep } from '@epi-pages/LoadBenefit/components/shared/SimpleFormStep';
import { FormStepMode } from '@epi-models/pages/Transfer';
import { TopupSchedule } from '@epi-pages/LoadBenefit/components/Topup/TopupForm/TopupSchedule';

interface ScheduleLoadProps {
  isLunchTopupRequest: boolean;
}

export const ScheduleLoad = ({ isLunchTopupRequest }: ScheduleLoadProps) => {
  const { t } = useTranslation();

  return (
    <SimpleFormStep
      mode={FormStepMode.Outlined}
      stepNumber={2}
      stepTitle={
        isLunchTopupRequest
          ? t('containers.deposit_money.topup_tab.form.schedule.title_lounari')
          : t('containers.deposit_money.topup_tab.form.schedule.title')
      }
      pr="70px"
    >
      <Box width={500} id="deposit_money_topup_step_two_schedule">
        <TopupSchedule />
      </Box>
    </SimpleFormStep>
  );
};
